export const CREATE_DATA_EXTRACT_SUCCESS = "CREATE_DATA_EXTRACT_SUCCESS";
export const LOAD_DATA_EXTRACTS_SUCCESS = "LOAD_DATA_EXTRACTS_SUCCESS";

export const CREATE_CUSTOMER_DATA_EXTRACT = "CREATE_CUSTOMER_DATA_EXTRACT";
export const CREATE_EMPLOYEE_DATA_EXTRACT = "CREATE_EMPLOYEE_DATA_EXTRACT";
export const LOAD_DATA_EXTRACTS = "LOAD_DATA_EXTRACTS";
